module.exports = __webpack_public_path__ + "static/media/modulo-comercial.6b1787f6.svg";